import { ThemeSchemaResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFlags } from '~/stores/use-flags/useFlags';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import * as S from './ThemeHeaderDetailed.styles';

export interface ThemeHeaderDetailedProps {
  theme: Pick<ThemeSchemaResponse, 'logo_url' | 'name' | 'description'>;
  title?: string;
}

export const ThemeHeaderDetailed = ({
  theme,
  title,
}: ThemeHeaderDetailedProps) => {
  const { t } = useTranslation(['widget']);
  const intradayThemePerfV1Enabled = useFlags(state =>
    state.getFeatureFlagState('intraday_theme_perf_v1')
  );
  return (
    <S.Header>
      <S.HeaderContent>
        <ThemeLogoIcon logo_url={theme.logo_url} name={theme.name} />
        <span>
          <S.TitleText>{title ?? theme.name}</S.TitleText>
          <S.SubtitleSmall>
            {t('assetOverview.knowledgeGraph.themeExposure.investmentTheme')}
          </S.SubtitleSmall>
        </span>
      </S.HeaderContent>
      {intradayThemePerfV1Enabled ? null : (
        <S.BodySmall>{theme.description}</S.BodySmall>
      )}
    </S.Header>
  );
};
